/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

require.config({
	shim: {
		'vs/base/common/marked/raw.marked': {
			exports: function () {
				return this.marked;
			}
		}
	}
});

define(__m[492/*vs/base/common/marked/marked*/], __M([503/*vs/base/common/marked/raw.marked*/]), function (marked) {
	return {
		marked: marked
	};
});